import { Box, GridItem, Heading, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { useExchangeableBooks, useGetMyBooksDetail } from '@partiu/api/bookstore/hooks';
import React, { useMemo } from 'react';
import { FaFrown } from 'react-icons/fa';
import { Params, useParams } from 'react-router-dom';
import { InfiniteScroll } from '../../../../../packages/ui/components/atoms/InfiniteScroll';
import { SectionTitle } from '../../../../../packages/ui/components/atoms/Title';
import { Labeled } from '../../../../../packages/ui/components/molecules/Labeled';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import { MainTemplate } from '../../templates/MainTemplate';
import ExchangeableBook from './components/ExchangeableBook';
import { BookCard } from '../../components/molecules/BookCard';

const ExchangeBookPage: React.FC = () => {
  const { bookUserId } = useParams();
  const { id, bookstoreLabels } = useTheme();

  const { data: bookDetailData } = useGetMyBooksDetail(bookUserId!, {
    enabled: !!bookUserId,
  });

  const hookProps = useMemo<Params>(
    () => ({ bookUserId: bookUserId, agreement: id?.toString() || '' }),
    [id, bookUserId]
  );

  return (
    <MainTemplate noShadow hideTopMenu>
      <VStack gap={5} align={'flex-start'} paddingBottom={'80px'} paddingTop={'24px'} width={'90%'}>
        <Labeled labelSize={'24px'} labelColor="rgba(0,0,0,0.6)" label={'Troca de Livro'} />

        {bookDetailData && (
          <VStack sx={{ width: '200px' }}>
            <BookCard book={bookDetailData.book} isActive={false} receivedBook={true} />
          </VStack>
        )}

        <Heading color="rgba(0,0,0,0.6)" as="h3" fontSize={'20px'} fontWeight="bold">
          Livros disponíveis para troca
        </Heading>
        <Text fontSize={'14px'} color={'#a9a9a9'}>
          Selecione um dos livros abaixo e confirme a troca. Lembre-se essa ação não pode ser desfeita! De toda forma,
          pode contactar nosso suporte.
        </Text>
        <Box width={'100%'} alignItems={'center'}>
          <InfiniteScroll
            keyExtraction={(book) => book.id.toString()}
            renderItem={(book) => (
              <GridItem>
                <ExchangeableBook book={book} bookUserId={bookUserId!} />
              </GridItem>
            )}
            emptyResultsComponent={
              <VStack paddingTop={'50px'} spacing={5}>
                <FaFrown size="36px" />
                <SectionTitle color="black">Nenhum {bookstoreLabels.singular} encontrado!</SectionTitle>
              </VStack>
            }
            mutationHook={useExchangeableBooks}
            hookProps={hookProps}
          >
            {(items) => (
              <SimpleGrid spacing={5} columns={{ base: 2, lg: 6 }}>
                {items}
              </SimpleGrid>
            )}
          </InfiniteScroll>
        </Box>
      </VStack>
    </MainTemplate>
  );
};

export default ExchangeBookPage;
